<template>
    <div class="content">
      <div class="container">
        <img :src="imgurl"/>
      </div>
      <div class="container">
        <p>{{text}}</p>
      </div>
    </div>

</template>

<script>
  export default {
    name: 'homeFooterImg',
    props: ['text', 'imgurl']
  }
</script>

<style scoped>

  div.content {
    padding: 0;
    padding-left: 25px;
    float: left;
    width: auto;
  }

  div.container {
    padding: 0;
    width: auto;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 0;
    margin-right: 0;
  }
  p {
    white-space: nowrap;
    font-size: 14px;
    font-family: 'ArialMT', 'Arial';
    font-weight: 400;
    font-style: normal;
    color: rgb(73,73,73);
    margin: auto;
    padding: 0;
    text-align: center;
  }

  img {
    max-width: 120px;
    max-height: 120px;
  }
</style>



// WEBPACK FOOTER //
// HomeFooterImg.vue?b0125260